<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">Report stock summary</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-print"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr class="blue">
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('code')}}</th>
                                        <th>{{$t('name')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('begin_stock')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('qty_order')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('qty_purchase')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('qty_sale_order')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('qty_sale')}}</th>
                                        <th class="text-center" style="width: 110px;">{{$t('qty_sale_return')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('ending_stock')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in records" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td class="text-center">{{ret.OldQuantity}}</td>
                                        <td class="text-center">{{ret.QuantityIn}}</td>
                                        <td class="text-center">{{ret.Quantity}}</td>
                                        <td class="text-center">{{ret.SaleQty2}}</td>
                                        <td class="text-center">{{ret.SaleQty1}}</td>
                                        <td class="text-center">{{ret.SaleQty3}}</td>
                                        <td class="text-center green">{{ret.StockInQty}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <br>
                            <div class="blue" style="font-weight: bold; padding: 3px 0;"><i class="fa fa-car" aria-hidden="true"></i> {{$t('stock_onhand')}}</div>
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr class="blue">
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('branch')}}</th>
                                        <th class="text-center">{{$t('qty')}}</th>
                                        <th class="text-center">{{$t('begin_stock')}}</th>
                                        <th class="text-center">{{$t('qty_in')}}</th>
                                        <th class="text-center">{{$t('qty_out')}}</th>
                                        <th class="text-center">{{$t('qty_transfer_in')}}</th>
                                        <th class="text-center">{{$t('qty_transfer_out')}}</th>
                                        <th class="text-center">{{$t('qty_sale_return')}}</th>
                                        <th class="text-center">{{$t('qty_damage')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in onhands" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.BranchName}}</td>
                                        <td class="text-center green">{{ret.Quantity}}</td>
                                        <td class="text-center">{{ret.BeginStock}}</td>
                                        <td class="text-center">{{ret.StockInQty}}</td>
                                        <td class="text-center">{{ret.StockOutQty}}</td>
                                        <td class="text-center">{{ret.TransferInQty}}</td>
                                        <td class="text-center">{{ret.TransferOutQty}}</td>
                                        <td class="text-center">{{ret.SaleReturnQty}}</td>
                                        <td class="text-center">{{ret.QuantityDamage}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            records: [],
            onhands: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('report/stock/item/summary', { ItemId: this.$route.params.id }).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Result;
                    this.onhands = res.data.Json.Onhands;
                }
            }).finally(function() { loading.hide(); });
        }
    }
}
</script>
<style scoped>
    .green{
        color: green !important;
    }
</style>
